// extracted by mini-css-extract-plugin
export default {"ServantDetails":"ServantDetails_ServantDetails__OyWyA","shad":"ServantDetails_shad__lI8JJ"};